import * as React from 'react';
import { memo } from 'react';

const SvgPlayV2 = (props) => (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M16.038 8.522 5.92 2.334a.563.563 0 0 0-.857.478v12.375a.561.561 0 0 0 .857.479l10.118-6.188a.555.555 0 0 0 0-.956Z", stroke: "currentColor", strokeWidth: 1.125, strokeLinecap: "round", strokeLinejoin: "round" })));
const Memo = memo(SvgPlayV2);

export { Memo as default };
